export default __webpack_public_path__ + "static/media/guide_create_1.a2d7912a.jpg";